export const NO_IMAGES_BACKGROUND =
  'https://uploadcare.engelvoelkers.com/a2851646-872c-4dca-a1bd-4631ae5b1313/-/format/webp/-/stretch/off/-/progressive/yes/';

export const PRIVATE_OFFICE_IMAGE_ROSE = 'https://uploadcare.engelvoelkers.com/447effc8-a5d9-4af6-880f-ae0f574563d9/';

export const DEFAULT_IMAGE_ID = '4a6e9b16-f2a8-4afc-ba26-a7d0cbcb1dbb';
